import { takeEvery, fork, call } from 'redux-saga/effects';
import { navigationActions } from 'src/redux/actions';
import StepsManager from 'src/utils/stepsManager';
import { browserHistory } from 'src/redux/store';
import { ONBOARDING_FORM_NAME } from 'src/constants/formNames';
import onboardingSteps from 'src/components/pages/onboarding/helpers/steps';
import complianceSteps from 'src/components/pages/compliance/helpers/steps';

const onboardingStepsManager = new StepsManager(onboardingSteps);
const complianceStepsManager = new StepsManager(complianceSteps);

function* navigateForward(action) {
  const {
    payload: { state },
  } = action;
  const formName = action.formName || state;
  let nextUrl;
  formName === ONBOARDING_FORM_NAME
    ? (nextUrl = onboardingStepsManager.getNextUrl(
        browserHistory.location.pathname,
        action.payload.state,
      ))
    : (nextUrl = complianceStepsManager.getNextUrl(
        browserHistory.location.pathname,
        action.payload.state,
      ));

  yield call(() => browserHistory.push(nextUrl));
}

function* navigateBack(action) {
  let backUrl;
  action.formName === ONBOARDING_FORM_NAME
    ? (backUrl = onboardingStepsManager.getBackUrl(
        browserHistory.location.pathname,
        action.payload.state,
      ))
    : (backUrl = complianceStepsManager.getBackUrl(
        browserHistory.location.pathname,
        action.payload.state,
      ));
  yield call(() => browserHistory.push(backUrl));
}

function* watchNavigationRequest() {
  yield takeEvery(navigationActions.types.NAVIGATE_BACK, navigateBack);
  yield takeEvery(navigationActions.types.NAVIGATE_FORWARD, navigateForward);
}

const navigationSagas = [fork(watchNavigationRequest)];

export default navigationSagas;
